export default "https://cdn-static-staging.gokick.com/assets/283628f6afcc58bd5c20cb35203f3b9e086ea5d6/images/choco-chill.f91442e53028d067e0a40cd80e4e8aae.png";